export const useInfoBox = ({ onClick }) => {
  const handleClick = (e) => {
    if (onClick) {
      onClick(e);
    }
  };

  return {
    handleClick,
  };
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/InfoBox/hooks/useInfoBox.js